import React from "react";
import { FiArrowDown } from "react-icons/fi";
import ThemeToggle from "./ThemeToggle";
import { RESUME_FILENAME, RESUME_URL } from "../data/profile";

// Compact top bar for phones and tablets; on desktop the sidebar takes this role.
const MobileBar = () => (
    <header className="sticky top-0 z-40 border-b border-fg/10 bg-ink/85 backdrop-blur-md lg:hidden">
        <div className="shell flex h-14 items-center justify-between gap-4">
            <a href="#top" className="flex items-center gap-3">
                <span aria-hidden="true" className="grid h-8 w-8 place-items-center bg-accent font-mono text-[11px] font-medium text-accent-fg">
                    PN
                </span>
                <span className="text-[15px] font-semibold tracking-tight">Paulin</span>
            </a>
            <div className="flex items-center gap-2">
                <a href={RESUME_URL} download={RESUME_FILENAME} className="btn btn-primary btn-sm">
                    <span>Resume</span>
                    <FiArrowDown className="btn-arrow btn-arrow-down" aria-hidden="true" />
                </a>
                <ThemeToggle />
            </div>
        </div>
    </header>
);

export default MobileBar;
